import { render, staticRenderFns } from "./ReviewClicks.vue?vue&type=template&id=6db951a4"
import script from "./ReviewClicks.vue?vue&type=script&lang=js"
export * from "./ReviewClicks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports